var vacancyBlock = {
    $vacancyBlock: $('.vacancy-block'),

    init: function() {
        var _this = this;

        _this.$tabs = _this.$vacancyBlock.find('.tabs');

        _this.slider();
    },

    slider: function() {
        var _this = this;

        _this.$tabs.slick({
            dots: true,
            appendDots: '.tab-navigation',
            customPaging: function(slider, i) {
                var title = $(slider.$slides[i])
                    .find('.tab-content')
                    .attr('title');

                return (
                    '<h3 class="custom-dot" role="button" title="' +
                    title +
                    '"><span class="string">' +
                    title +
                    '</span></h3>'
                );
            },
            arrows: false,
            infinite: true,
            adaptiveHeight: true,
            speed: 500,
            fade: true,
            cssEase: 'linear'
        });
    }
};
